module.exports = __webpack_public_path__ + "img/dreamroom_thumbnail.aea6f2a9.webp";